// extracted by mini-css-extract-plugin
export var active = "steps-module--active--m8Nyd";
export var big_circle = "steps-module--big_circle--vOM3A";
export var circle_step = "steps-module--circle_step--hLiC1";
export var img = "steps-module--img--uGbYg";
export var mobile_container = "steps-module--mobile_container--nraZ8";
export var mobile_step = "steps-module--mobile_step--2B4C1";
export var mobile_steps_count = "steps-module--mobile_steps_count--lJkLJ";
export var mobile_steps_descriotion = "steps-module--mobile_steps_descriotion--lRVN8";
export var mocaps = "steps-module--mocaps--ODuJT";
export var progress = "steps-module--progress--qQbCS";
export var progress_container = "steps-module--progress_container--wuG8J";
export var step = "steps-module--step--Z49Ze";
export var step_description = "steps-module--step_description--JLeq0";
export var step_wrapper_4 = "steps-module--step_wrapper_4--64J4x";
export var step_wrapper_5 = "steps-module--step_wrapper_5--cgrqE";
export var step_wrapper_6 = "steps-module--step_wrapper_6--cDePc";
export var steps = "steps-module--steps--IqNG7";
export var text_description = "steps-module--text_description--vHAzH";
export var wrapper = "steps-module--wrapper--yMJBp";